import React from 'react';
import c from '../w.js';

const IconFileDocument = React.memo(
  c(
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M2 5C2 4.44772 2.44772 4 3 4H21C21.5523 4 22 4.44772 22 5V6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6V5Z" }), /* @__PURE__ */ React.createElement("path", { d: "M2 11C2 10.4477 2.44772 10 3 10H21C21.5523 10 22 10.4477 22 11V12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12V11Z" }), /* @__PURE__ */ React.createElement("path", { d: "M18 17C18 16.4477 17.5523 16 17 16H3C2.44772 16 2 16.4477 2 17V18C2 18.5523 2.44772 19 3 19H17C17.5523 19 18 18.5523 18 18V17Z" }))
  )
);

export { IconFileDocument };
